import React, { type SVGAttributes } from 'react';

const strokeProps = {
  stroke: 'var(--stroke, currentColor)',
  strokeWidth: 'var(--stroke-width, 1.66667)',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  fill: 'none',
} as const;

const fillProps = {
  fill: 'var(--fill, currentColor)',
  fillOpacity: 'var(--fill-opacity, 0.12)',
} as const;

const svgProps: SVGAttributes<SVGElement> = {
  viewBox: '0 0 24 24',
  width: '24px',
  height: '24px',
} as const;

export const Mail: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M13.8351 12.7154C13.1739 13.1783 12.8433 13.4097 12.4837 13.4993C12.1661 13.5785 11.8339 13.5785 11.5163 13.4993C11.1567 13.4097 10.8261 13.1783 10.1649 12.7154L2 7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7L13.8351 12.7154Z"
        {...fillProps}
      />
      <path
        d="M2 7L10.1649 12.7154C10.8261 13.1783 11.1567 13.4097 11.5163 13.4993C11.8339 13.5785 12.1661 13.5785 12.4837 13.4993C12.8433 13.4097 13.1739 13.1783 13.8351 12.7154L22 7M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z"
        {...strokeProps}
      />
    </svg>
  );
};
export const CalendarDate: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M3 8.8C3 7.11984 3 6.27976 3.32698 5.63803C3.6146 5.07354 4.07354 4.6146 4.63803 4.32698C5.27976 4 6.11984 4 7.8 4H16.2C17.8802 4 18.7202 4 19.362 4.32698C19.9265 4.6146 20.3854 5.07354 20.673 5.63803C21 6.27976 21 7.11984 21 8.8V10H3V8.8Z"
        {...fillProps}
      />
      <path
        d="M21 10H3M16 2V6M8 2V6M10.5 14L12 13V18M10.75 18H13.25M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Key: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M21 9C21 12.3137 18.3137 15 15 15C14.7263 15 14.4569 14.9817 14.193 14.9462C13.7588 14.8878 13.5417 14.8586 13.4044 14.8783C13.2613 14.8987 13.1843 14.9248 13.0581 14.9953C12.937 15.063 12.8177 15.1823 12.5791 15.4209L11 17H9V19H7V21H4.6C4.03995 21 3.75992 21 3.54601 20.891C3.35785 20.7951 3.20487 20.6422 3.10899 20.454C3 20.2401 3 19.9601 3 19.4V17.6627C3 17.4182 3 17.2959 3.02763 17.1808C3.05213 17.0787 3.09253 16.9812 3.14736 16.8917C3.2092 16.7908 3.29568 16.7043 3.46863 16.5314L8.57913 11.4209C8.81771 11.1823 8.937 11.063 9.00469 10.9419C9.0752 10.8157 9.10125 10.7387 9.12172 10.5956C9.14136 10.4583 9.11218 10.2412 9.05381 9.80704C9.01832 9.54308 9 9.27368 9 9C9 5.68629 11.6863 3 15 3C18.3137 3 21 5.68629 21 9Z"
        {...fillProps}
      />
      <path
        d="M17 8.99994C17 8.48812 16.8047 7.9763 16.4142 7.58579C16.0237 7.19526 15.5118 7 15 7M15 15C18.3137 15 21 12.3137 21 9C21 5.68629 18.3137 3 15 3C11.6863 3 9 5.68629 9 9C9 9.27368 9.01832 9.54308 9.05381 9.80704C9.11218 10.2412 9.14136 10.4583 9.12172 10.5956C9.10125 10.7387 9.0752 10.8157 9.00469 10.9419C8.937 11.063 8.81771 11.1823 8.57913 11.4209L3.46863 16.5314C3.29568 16.7043 3.2092 16.7908 3.14736 16.8917C3.09253 16.9812 3.05213 17.0787 3.02763 17.1808C3 17.2959 3 17.4182 3 17.6627V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H7V19H9V17H11L12.5791 15.4209C12.8177 15.1823 12.937 15.063 13.0581 14.9953C13.1843 14.9248 13.2613 14.8987 13.4044 14.8783C13.5417 14.8586 13.7588 14.8878 14.193 14.9462C14.4569 14.9817 14.7263 15 15 15Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Warning: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M2.39043 18.0983L10.6153 3.89171C11.0699 3.10655 11.2972 2.71396 11.5937 2.58211C11.8524 2.4671 12.1476 2.4671 12.4063 2.58211C12.7028 2.71396 12.9301 3.10654 13.3847 3.89171L21.6096 18.0983C22.0658 18.8863 22.2939 19.2803 22.2602 19.6037C22.2308 19.8857 22.083 20.142 21.8536 20.3088C21.5907 20.5 21.1354 20.5 20.2249 20.5H3.77511C2.86459 20.5 2.40933 20.5 2.14637 20.3088C1.91701 20.142 1.76924 19.8857 1.73984 19.6037C1.70612 19.2803 1.93423 18.8863 2.39043 18.0983Z"
        {...fillProps}
      />
      <path
        d="M12 8.99999V13M12 17H12.01M10.6153 3.89171L2.39043 18.0983C1.93423 18.8863 1.70612 19.2803 1.73984 19.6037C1.76924 19.8857 1.91701 20.142 2.14637 20.3088C2.40933 20.5 2.86459 20.5 3.77511 20.5H20.2249C21.1354 20.5 21.5907 20.5 21.8536 20.3088C22.083 20.142 22.2308 19.8857 22.2602 19.6037C22.2939 19.2803 22.0658 18.8863 21.6096 18.0983L13.3847 3.89171C12.9301 3.10654 12.7028 2.71396 12.4063 2.58211C12.1476 2.4671 11.8524 2.4671 11.5937 2.58211C11.2972 2.71396 11.0699 3.10655 10.6153 3.89171Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Alarm: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M12 21C14.1217 21 16.1566 20.1571 17.6569 18.6569C19.1571 17.1566 20 15.1217 20 13C20 10.8783 19.1571 8.84344 17.6569 7.34315C16.1566 5.84285 14.1217 5 12 5C9.87827 5 7.84344 5.84285 6.34315 7.34315C4.84285 8.84344 4 10.8783 4 13C4 15.1217 4.84285 17.1566 6.34315 18.6569C7.84344 20.1571 9.87827 21 12 21Z"
        {...fillProps}
      />
      <path
        d="M5 3L2 6M22 6L19 3M6 19L4 21M18 19L20 21M9 13.5L11 15.5L15.5 11M12 21C14.1217 21 16.1566 20.1571 17.6569 18.6569C19.1571 17.1566 20 15.1217 20 13C20 10.8783 19.1571 8.84344 17.6569 7.34315C16.1566 5.84285 14.1217 5 12 5C9.87827 5 7.84344 5.84285 6.34315 7.34315C4.84286 8.84344 4 10.8783 4 13C4 15.1217 4.84286 17.1566 6.34315 18.6569C7.84344 20.1571 9.87827 21 12 21Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const BarChart: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M8 15V17M12 11V17M16 7V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Circle: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M9.13626 9.13628L4.92893 4.92896M4.92893 19.0711L9.16797 14.8321M14.8611 14.8638L19.0684 19.0711M19.0684 4.92896L14.8287 9.16862M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Eye: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        {...fillProps}
      />
      <path
        d="M2.41976 12.7132C2.28357 12.4975 2.21548 12.3897 2.17736 12.2234C2.14873 12.0985 2.14873 11.9015 2.17736 11.7766C2.21548 11.6103 2.28357 11.5025 2.41976 11.2868C3.54516 9.50484 6.89503 5 12 5C17.105 5 20.4549 9.50484 21.5803 11.2868C21.7165 11.5025 21.7846 11.6103 21.8227 11.7766C21.8513 11.9015 21.8513 12.0985 21.8227 12.2234C21.7846 12.3897 21.7165 12.4975 21.5803 12.7132C20.4549 14.4952 17.105 19 12 19C6.89503 19 3.54516 14.4952 2.41976 12.7132Z"
        {...strokeProps}
      />
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3432 9 9.00004 10.3431 9.00004 12C9.00004 13.6569 10.3432 15 12 15Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Gear: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        {...strokeProps}
      />
      <path
        d="M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Home: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M8.12602 14C8.57006 15.7252 10.1362 17 12 17C13.8638 17 15.4299 15.7252 15.874 14M11.0177 2.764L4.23539 8.03912C3.78202 8.39175 3.55534 8.56806 3.39203 8.78886C3.24737 8.98444 3.1396 9.20478 3.07403 9.43905C3 9.70352 3 9.9907 3 10.5651V17.8C3 18.9201 3 19.4801 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4801 21 18.9201 21 17.8V10.5651C21 9.9907 21 9.70352 20.926 9.43905C20.8604 9.20478 20.7526 8.98444 20.608 8.78886C20.4447 8.56806 20.218 8.39175 19.7646 8.03913L12.9823 2.764C12.631 2.49075 12.4553 2.35412 12.2613 2.3016C12.0902 2.25526 11.9098 2.25526 11.7387 2.3016C11.5447 2.35412 11.369 2.49075 11.0177 2.764Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Lightbulb: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M15.5 16.874C17.0141 15.7848 18 14.0075 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 14.0075 6.98593 15.7848 8.5 16.874V18.8C8.5 19.9201 8.5 20.4802 8.71799 20.908C8.90973 21.2843 9.21569 21.5903 9.59202 21.782C10.0198 22 10.5799 22 11.7 22H12.3C13.4201 22 13.9802 22 14.408 21.782C14.7843 21.5903 15.0903 21.2843 15.282 20.908C15.5 20.4802 15.5 19.9201 15.5 18.8V16.874Z"
        {...fillProps}
      />
      <path
        d="M12 2V3M3 12H2M5.5 5.5L4.8999 4.8999M18.5 5.5L19.1002 4.8999M22 12H21M10 13.5H14M12 13.5V18.5M15.5 16.874C17.0141 15.7848 18 14.0075 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 14.0075 6.98593 15.7848 8.5 16.874V18.8C8.5 19.9201 8.5 20.4802 8.71799 20.908C8.90973 21.2843 9.21569 21.5903 9.59202 21.782C10.0198 22 10.5799 22 11.7 22H12.3C13.4201 22 13.9802 22 14.408 21.782C14.7843 21.5903 15.0903 21.2843 15.282 20.908C15.5 20.4802 15.5 19.9201 15.5 18.8V16.874Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Clipboard: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H12.5L4 16.5V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22Z"
        {...fillProps}
      />
      <path
        d="M12.5 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V16.5M16 13H11.5M16 9H12.5M16 17H8M6 10V4.5C6 3.67157 6.67157 3 7.5 3C8.32843 3 9 3.67157 9 4.5V10C9 11.6569 7.65685 13 6 13C4.34315 13 3 11.6569 3 10V6"
        {...strokeProps}
      />
    </svg>
  );
};

export const Logout: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M16 17L21 12M21 12L16 7M21 12H9M9 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H9"
        {...strokeProps}
      />
    </svg>
  );
};

export const MessageHeart: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.2C21 14.8802 21 15.7202 20.673 16.362C20.3854 16.9265 19.9265 17.3854 19.362 17.673C18.7202 18 17.8802 18 16.2 18H13.6837C13.0597 18 12.7477 18 12.4492 18.0613C12.1844 18.1156 11.9282 18.2055 11.6875 18.3285C11.4162 18.4671 11.1725 18.662 10.6852 19.0518L8.29976 20.9602C7.88367 21.2931 7.67563 21.4595 7.50054 21.4597C7.34827 21.4599 7.20422 21.3906 7.10923 21.2716C7 21.1348 7 20.8684 7 20.3355V18C6.07003 18 5.60504 18 5.22354 17.8978C4.18827 17.6204 3.37962 16.8117 3.10222 15.7765C3 15.395 3 14.93 3 14V7.8Z"
        {...strokeProps}
      />
      <path
        d="M11.9969 7.69925C11.0972 6.6604 9.59689 6.38095 8.46961 7.33223C7.34234 8.2835 7.18364 9.87399 8.06889 10.9991C8.61733 11.6961 9.99389 12.9691 10.962 13.837C11.3176 14.1557 11.4953 14.3151 11.7087 14.3793C11.8918 14.4344 12.1021 14.4344 12.2851 14.3793C12.4985 14.3151 12.6763 14.1557 13.0319 13.837C13.9999 12.9691 15.3765 11.6961 15.9249 10.9991C16.8102 9.87399 16.6709 8.2735 15.5242 7.33223C14.3776 6.39096 12.8966 6.6604 11.9969 7.69925Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const People: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
        {...strokeProps}
      />
    </svg>
  );
};
export const PeopleWithLeftArrow: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M9.5 11C11.7091 11 13.5 9.20914 13.5 7C13.5 4.79086 11.7091 3 9.5 3C7.29086 3 5.5 4.79086 5.5 7C5.5 9.20914 7.29086 11 9.5 11Z"
        {...fillProps}
      />
      <path
        d="M19 21L16 18M16 18L19 15M16 18H22M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Rocket: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M12 15L9 12C9.53214 10.6194 10.2022 9.29607 11 8.05C12.1652 6.18699 13.7876 4.65305 15.713 3.5941C17.6384 2.53514 19.8027 1.98637 22 2C22 4.72 21.22 9.5 16 13C14.7369 13.7987 13.3968 14.4687 12 15Z"
        {...fillProps}
      />
      <path
        d="M12 15L9 12M12 15C13.3968 14.4687 14.7369 13.7987 16 13M12 15V20C12 20 15.03 19.45 16 18C17.08 16.38 16 13 16 13M9 12C9.53214 10.6194 10.2022 9.29607 11 8.05C12.1652 6.18699 13.7876 4.65305 15.713 3.5941C17.6384 2.53514 19.8027 1.98637 22 2C22 4.72 21.22 9.5 16 13M9 12H4C4 12 4.55 8.97 6 8C7.62 6.92 11 8 11 8M4.5 16.5C3 17.76 2.5 21.5 2.5 21.5C2.5 21.5 6.24 21 7.5 19.5C8.21 18.66 8.2 17.37 7.41 16.59C7.02131 16.219 6.50929 16.0046 5.97223 15.988C5.43516 15.9714 4.91088 16.1537 4.5 16.5Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const SadFace: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        {...fillProps}
      />
      <path
        d="M16 16C16 16 14.5 14 12 14C9.5 14 8 16 8 16M17 9.24C16.605 9.725 16.065 10 15.5 10C14.935 10 14.41 9.725 14 9.24M10 9.24C9.605 9.725 9.065 10 8.5 10C7.935 10 7.41 9.725 7 9.24M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Search: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
        {...fillProps}
      />
      <path
        d="M21 21L15.0001 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Wand: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M3.13134 20.1314C2.73533 19.7354 2.53732 19.5373 2.46313 19.309C2.39787 19.1082 2.39787 18.8918 2.46313 18.691C2.53732 18.4627 2.73532 18.2646 3.13134 17.8686L9.99997 11L13 14L6.13134 20.8686C5.73532 21.2646 5.53732 21.4627 5.30899 21.5368C5.10814 21.6021 4.8918 21.6021 4.69095 21.5368C4.46263 21.4627 4.26462 21.2646 3.8686 20.8686L3.13134 20.1314Z"
        {...fillProps}
      />
      <path
        d="M13 14L9.99997 11M15.0103 3.5V2M18.9497 5.06066L20.0103 4M18.9497 13L20.0103 14.0607M11.0103 5.06066L9.94966 4M20.5103 9H22.0103M6.13134 20.8686L15.3686 11.6314C15.7646 11.2354 15.9626 11.0373 16.0368 10.809C16.1021 10.6082 16.1021 10.3918 16.0368 10.191C15.9626 9.96265 15.7646 9.76465 15.3686 9.36863L14.6313 8.63137C14.2353 8.23535 14.0373 8.03735 13.809 7.96316C13.6081 7.8979 13.3918 7.8979 13.191 7.96316C12.9626 8.03735 12.7646 8.23535 12.3686 8.63137L3.13134 17.8686C2.73532 18.2646 2.53732 18.4627 2.46313 18.691C2.39787 18.8918 2.39787 19.1082 2.46313 19.309C2.53732 19.5373 2.73533 19.7354 3.13134 20.1314L3.8686 20.8686C4.26462 21.2646 4.46263 21.4627 4.69095 21.5368C4.8918 21.6021 5.10814 21.6021 5.30899 21.5368C5.53732 21.4627 5.73533 21.2646 6.13134 20.8686Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const TrashCan: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M19 17.2V6H5V17.2C5 18.8802 5 19.7202 5.32698 20.362C5.6146 20.9265 6.07354 21.3854 6.63803 21.673C7.27976 22 8.11984 22 9.8 22H14.2C15.8802 22 16.7202 22 17.362 21.673C17.9265 21.3854 18.3854 20.9265 18.673 20.362C19 19.7202 19 18.8802 19 17.2Z"
        {...fillProps}
      />
      <path
        d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6"
        {...strokeProps}
      />
    </svg>
  );
};

export const PlusCircle: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        {...fillProps}
      />
      <path
        d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Plus: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path d="M12 5V19M5 12H19" {...strokeProps} />
    </svg>
  );
};

export const DraggerHandle: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
        {...strokeProps}
      />
      <path
        d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
        {...strokeProps}
      />
      <path
        d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const CompareMatrix1: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M12 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V12H12V3Z"
        {...fillProps}
      />
      <path
        d="M21 12H12V21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V12Z"
        {...fillProps}
      />
      <path
        d="M3 12H21M12 3V21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Charts: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z"
        {...fillProps}
      />
      <path
        d="M8 15V17M12 11V17M16 7V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const LeftArrow: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        {...fillProps}
      />
      <path
        d="M12 8L8 12M8 12L12 16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const HeartHand: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M17.1914 3.59226C16.5946 2.3434 15.2186 1.68179 13.8804 2.32037C12.5423 2.95896 11.9722 4.47338 12.5325 5.80283C13.0927 7.13227 15.3437 10.4879 15.3437 10.4879C15.3437 10.4879 18.9709 8.70733 20.1208 7.83612C21.2707 6.96492 21.5556 5.36358 20.6947 4.14624C19.8337 2.9289 18.3327 2.80912 17.1914 3.59226Z"
        {...fillProps}
      />
      <path
        d="M6 20.0872H8.61029C8.95063 20.0872 9.28888 20.1277 9.61881 20.2087L12.3769 20.8789C12.9753 21.0247 13.5988 21.0389 14.2035 20.9214L17.253 20.3281C18.0585 20.1712 18.7996 19.7855 19.3803 19.2205L21.5379 17.1217C22.154 16.5234 22.154 15.5524 21.5379 14.9531C20.9832 14.4135 20.1047 14.3527 19.4771 14.8103L16.9626 16.6449C16.6025 16.9081 16.1643 17.0498 15.7137 17.0498H13.2855L14.8311 17.0498C15.7022 17.0498 16.4079 16.3633 16.4079 15.5159V15.2092C16.4079 14.5055 15.9156 13.892 15.2141 13.7219L12.8286 13.1418C12.4404 13.0476 12.0428 13 11.6431 13C10.6783 13 8.93189 13.7988 8.93189 13.7988L6 15.0249M2 14.6L2 20.4C2 20.9601 2 21.2401 2.10899 21.454C2.20487 21.6422 2.35785 21.7951 2.54601 21.891C2.75992 22 3.03995 22 3.6 22H4.4C4.96005 22 5.24008 22 5.45399 21.891C5.64215 21.7952 5.79513 21.6422 5.89101 21.454C6 21.2401 6 20.9601 6 20.4V14.6C6 14.04 6 13.7599 5.89101 13.546C5.79513 13.3579 5.64215 13.2049 5.45399 13.109C5.24008 13 4.96005 13 4.4 13H3.6C3.03995 13 2.75992 13 2.54601 13.109C2.35785 13.2049 2.20487 13.3579 2.10899 13.546C2 13.7599 2 14.04 2 14.6ZM17.1914 3.59227C16.5946 2.34341 15.2186 1.6818 13.8804 2.32039C12.5423 2.95898 11.9722 4.4734 12.5325 5.80284C12.8787 6.62448 13.8707 8.22002 14.5781 9.31905C14.8394 9.72513 14.9701 9.92817 15.161 10.0469C15.3247 10.1488 15.5297 10.2037 15.7224 10.1974C15.9471 10.1899 16.1618 10.0794 16.5911 9.85845C17.7532 9.26033 19.4101 8.37457 20.1208 7.83614C21.2707 6.96494 21.5556 5.36359 20.6947 4.14626C19.8337 2.92892 18.3327 2.80914 17.1914 3.59227Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Workspaces: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M16.2 21C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27977 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3L7.8 3C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8L3 16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2Z"
        {...fillProps}
      />
      <path
        d="M7.5 12H7.51M16.5 12H16.51M12 12H12.01M12 16.5H12.01M12 7.5H12.01M3 7.8L3 16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27977 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3L7.8 3C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const KeyAdmin: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M21 9C21 12.3137 18.3137 15 15 15C14.7263 15 14.4569 14.9817 14.193 14.9462C13.7588 14.8878 13.5417 14.8586 13.4044 14.8783C13.2613 14.8987 13.1843 14.9248 13.0581 14.9953C12.937 15.063 12.8177 15.1823 12.5791 15.4209L11 17H9V19H7V21H4.6C4.03995 21 3.75992 21 3.54601 20.891C3.35785 20.7951 3.20487 20.6422 3.10899 20.454C3 20.2401 3 19.9601 3 19.4V17.6627C3 17.4182 3 17.2959 3.02763 17.1808C3.05213 17.0787 3.09253 16.9812 3.14736 16.8917C3.2092 16.7908 3.29568 16.7043 3.46863 16.5314L8.57913 11.4209C8.81771 11.1823 8.937 11.063 9.00469 10.9419C9.0752 10.8157 9.10125 10.7387 9.12172 10.5956C9.14136 10.4583 9.11218 10.2412 9.05381 9.80704C9.01832 9.54308 9 9.27368 9 9C9 5.68629 11.6863 3 15 3C18.3137 3 21 5.68629 21 9Z"
        {...fillProps}
      />
      <path
        d="M17 8.99994C17 8.48812 16.8047 7.9763 16.4142 7.58579C16.0237 7.19526 15.5118 7 15 7M15 15C18.3137 15 21 12.3137 21 9C21 5.68629 18.3137 3 15 3C11.6863 3 9 5.68629 9 9C9 9.27368 9.01832 9.54308 9.05381 9.80704C9.11218 10.2412 9.14136 10.4583 9.12172 10.5956C9.10125 10.7387 9.0752 10.8157 9.00469 10.9419C8.937 11.063 8.81771 11.1823 8.57913 11.4209L3.46863 16.5314C3.29568 16.7043 3.2092 16.7908 3.14736 16.8917C3.09253 16.9812 3.05213 17.0787 3.02763 17.1808C3 17.2959 3 17.4182 3 17.6627V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H7V19H9V17H11L12.5791 15.4209C12.8177 15.1823 12.937 15.063 13.0581 14.9953C13.1843 14.9248 13.2613 14.8987 13.4044 14.8783C13.5417 14.8586 13.7588 14.8878 14.193 14.9462C14.4569 14.9817 14.7263 15 15 15Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Chevron: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path d="M9 18L15 12L9 6" {...strokeProps} />
    </svg>
  );
};

export const DoubleChevron: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path d="M18 17L13 12L18 7M11 17L6 12L11 7" {...strokeProps} />
    </svg>
  );
};
export const KeyIcon: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        {...strokeProps}
        d="M21 9C21 12.3137 18.3137 15 15 15C14.7263 15 14.4569 14.9817 14.193 14.9462C13.7588 14.8878 13.5417 14.8586 13.4044 14.8783C13.2613 14.8987 13.1843 14.9248 13.0581 14.9953C12.937 15.063 12.8177 15.1823 12.5791 15.4209L11 17H9V19H7V21H4.6C4.03995 21 3.75992 21 3.54601 20.891C3.35785 20.7951 3.20487 20.6422 3.10899 20.454C3 20.2401 3 19.9601 3 19.4V17.6627C3 17.4182 3 17.2959 3.02763 17.1808C3.05213 17.0787 3.09253 16.9812 3.14736 16.8917C3.2092 16.7908 3.29568 16.7043 3.46863 16.5314L8.57913 11.4209C8.81771 11.1823 8.937 11.063 9.00469 10.9419C9.0752 10.8157 9.10125 10.7387 9.12172 10.5956C9.14136 10.4583 9.11218 10.2412 9.05381 9.80704C9.01832 9.54308 9 9.27368 9 9C9 5.68629 11.6863 3 15 3C18.3137 3 21 5.68629 21 9Z"
      />
      <path
        d="M17 8.99994C17 8.48812 16.8047 7.9763 16.4142 7.58579C16.0237 7.19526 15.5118 7 15 7M15 15C18.3137 15 21 12.3137 21 9C21 5.68629 18.3137 3 15 3C11.6863 3 9 5.68629 9 9C9 9.27368 9.01832 9.54308 9.05381 9.80704C9.11218 10.2412 9.14136 10.4583 9.12172 10.5956C9.10125 10.7387 9.0752 10.8157 9.00469 10.9419C8.937 11.063 8.81771 11.1823 8.57913 11.4209L3.46863 16.5314C3.29568 16.7043 3.2092 16.7908 3.14736 16.8917C3.09253 16.9812 3.05213 17.0787 3.02763 17.1808C3 17.2959 3 17.4182 3 17.6627V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H7V19H9V17H11L12.5791 15.4209C12.8177 15.1823 12.937 15.063 13.0581 14.9953C13.1843 14.9248 13.2613 14.8987 13.4044 14.8783C13.5417 14.8586 13.7588 14.8878 14.193 14.9462C14.4569 14.9817 14.7263 15 15 15Z"
        {...strokeProps}
      />
    </svg>
  );
};
export const User: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M12 12C14.4853 12 16.5 9.98528 16.5 7.5C16.5 5.01472 14.4853 3 12 3C9.51472 3 7.5 5.01472 7.5 7.5C7.5 9.98528 9.51472 12 12 12Z"
        {...fillProps}
      />
      <path
        d="M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const ArrowLeft: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path d="M19 12H5M5 12L12 19M5 12L12 5" {...strokeProps} />
    </svg>
  );
};

export const Pencil: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M2.87604 18.1156C2.92198 17.7021 2.94496 17.4954 3.00751 17.3022C3.06301 17.1307 3.14143 16.9676 3.24064 16.8171C3.35246 16.6475 3.49955 16.5005 3.79373 16.2063L17 3C18.1046 1.89543 19.8955 1.89543 21 3C22.1046 4.10457 22.1046 5.89543 21 7L7.79373 20.2063C7.49955 20.5005 7.35245 20.6475 7.18289 20.7594C7.03245 20.8586 6.86929 20.937 6.69785 20.9925C6.5046 21.055 6.29786 21.078 5.88437 21.124L2.5 21.5L2.87604 18.1156Z"
        {...fillProps}
      />
      <path
        d="M2.87604 18.1156C2.92198 17.7021 2.94496 17.4954 3.00751 17.3022C3.06301 17.1307 3.14143 16.9676 3.24064 16.8171C3.35246 16.6475 3.49955 16.5005 3.79373 16.2063L17 3C18.1046 1.89543 19.8955 1.89543 21 3C22.1046 4.10457 22.1046 5.89543 21 7L7.79373 20.2063C7.49955 20.5005 7.35245 20.6475 7.18289 20.7594C7.03245 20.8586 6.86929 20.937 6.69785 20.9925C6.5046 21.055 6.29786 21.078 5.88437 21.124L2.5 21.5L2.87604 18.1156Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const MessageHeartIcon: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M11.9969 7.69925C11.0972 6.6604 9.59689 6.38095 8.46961 7.33223C7.34234 8.2835 7.18364 9.87399 8.06889 10.9991C8.61733 11.6961 9.99389 12.9691 10.962 13.837C11.3176 14.1557 11.4953 14.3151 11.7087 14.3793C11.8918 14.4344 12.1021 14.4344 12.2851 14.3793C12.4985 14.3151 12.6763 14.1557 13.0319 13.837C13.9999 12.9691 15.3765 11.6961 15.9249 10.9991C16.8102 9.87399 16.6709 8.2735 15.5242 7.33223C14.3776 6.39096 12.8966 6.6604 11.9969 7.69925Z"
        {...strokeProps}
      />
      <path
        d="M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.2C21 14.8802 21 15.7202 20.673 16.362C20.3854 16.9265 19.9265 17.3854 19.362 17.673C18.7202 18 17.8802 18 16.2 18H13.6837C13.0597 18 12.7477 18 12.4492 18.0613C12.1844 18.1156 11.9282 18.2055 11.6875 18.3285C11.4162 18.4671 11.1725 18.662 10.6852 19.0518L8.29976 20.9602C7.88367 21.2931 7.67563 21.4595 7.50054 21.4597C7.34827 21.4599 7.20422 21.3906 7.10923 21.2716C7 21.1348 7 20.8684 7 20.3355V18C6.07003 18 5.60504 18 5.22354 17.8978C4.18827 17.6204 3.37962 16.8117 3.10222 15.7765C3 15.395 3 14.93 3 14V7.8Z"
        {...strokeProps}
      />
      <path
        d="M11.9969 7.69925C11.0972 6.6604 9.59689 6.38095 8.46961 7.33223C7.34234 8.2835 7.18364 9.87399 8.06889 10.9991C8.61733 11.6961 9.99389 12.9691 10.962 13.837C11.3176 14.1557 11.4953 14.3151 11.7087 14.3793C11.8918 14.4344 12.1021 14.4344 12.2851 14.3793C12.4985 14.3151 12.6763 14.1557 13.0319 13.837C13.9999 12.9691 15.3765 11.6961 15.9249 10.9991C16.8102 9.87399 16.6709 8.2735 15.5242 7.33223C14.3776 6.39096 12.8966 6.6604 11.9969 7.69925Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Comment: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M21 12C21 16.9706 16.9706 21 12 21C10.8029 21 9.6603 20.7663 8.61549 20.3419C8.41552 20.2607 8.31554 20.2201 8.23472 20.202C8.15566 20.1843 8.09715 20.1778 8.01613 20.1778C7.9333 20.1778 7.84309 20.1928 7.66265 20.2229L4.10476 20.8159C3.73218 20.878 3.54589 20.909 3.41118 20.8512C3.29328 20.8007 3.19933 20.7067 3.14876 20.5888C3.09098 20.4541 3.12203 20.2678 3.18413 19.8952L3.77711 16.3374C3.80718 16.1569 3.82222 16.0667 3.82221 15.9839C3.8222 15.9028 3.81572 15.8443 3.798 15.7653C3.77988 15.6845 3.73927 15.5845 3.65806 15.3845C3.23374 14.3397 3 13.1971 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        {...fillProps}
      />
      <path
        d="M8 9.5H12M8 13H15M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21Z"
        {...strokeProps}
      />
    </svg>
  );
};
export const Branch: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8C15 9.65685 16.3431 11 18 11Z"
        {...strokeProps}
      />
      <path
        d="M18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15C16.3431 15 15 16.3431 15 18C15 19.6569 16.3431 21 18 21Z"
        {...strokeProps}
      />
      <path
        d="M3 3V13.2C3 14.8802 3 15.7202 3.32698 16.362C3.6146 16.9265 4.07354 17.3854 4.63803 17.673C5.27976 18 6.11984 18 7.8 18H15M15 18C15 19.6569 16.3431 21 18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15C16.3431 15 15 16.3431 15 18ZM3 8L15 8M15 8C15 9.65686 16.3431 11 18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Dragger: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M16 6C16.5523 6 17 5.55228 17 5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5C15 5.55228 15.4477 6 16 6Z"
        {...strokeProps}
      />
      <path
        d="M16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z"
        {...strokeProps}
      />
      <path
        d="M16 20C16.5523 20 17 19.5523 17 19C17 18.4477 16.5523 18 16 18C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20Z"
        {...strokeProps}
      />
      <path
        d="M8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6Z"
        {...strokeProps}
      />
      <path
        d="M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z"
        {...strokeProps}
      />
      <path
        d="M8 20C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18C7.44772 18 7 18.4477 7 19C7 19.5523 7.44772 20 8 20Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const ChevronDown: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path d="M6 9L12 15L18 9" {...strokeProps} />
    </svg>
  );
};

export const ArrowRight: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path d="M5 12H19M19 12L12 5M19 12L12 19" {...strokeProps} />
    </svg>
  );
};

export const FilePlus: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11982 22 8.79993 22H12L20 10.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2Z"
        {...fillProps}
      />
      <path
        d="M20 10.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M14 11H8M10 15H8M16 7H8M18 21V15M15 18H21"
        {...strokeProps}
      />
    </svg>
  );
};

export const FilePlus2: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M19.1213 7.12139L14.8787 2.87875C14.6222 2.62223 14.324 2.41696 14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305C19.5831 7.67611 19.3778 7.37792 19.1213 7.12139Z"
        {...fillProps}
      />
      <path
        d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M12 18V12M9 15H15M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Intersect: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M16 9C16 12.866 12.866 16 9 16C8.68203 16 8.369 15.9788 8.06227 15.9377C8.0212 15.631 8 15.318 8 15C8 11.134 11.134 8 15 8C15.318 8 15.631 8.0212 15.9377 8.06227C15.9788 8.369 16 8.68203 16 9Z"
        {...fillProps}
      />
      <path
        d="M9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16Z"
        {...strokeProps}
      />
      <path
        d="M15 22C18.866 22 22 18.866 22 15C22 11.134 18.866 8 15 8C11.134 8 8 11.134 8 15C8 18.866 11.134 22 15 22Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Atom: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M17.1153 15.3582C16.8446 15.6642 16.5605 15.9665 16.2635 16.2635C11.9677 20.5593 6.58579 22.1422 4.24264 19.7991C2.63624 18.1926 2.87514 15.158 4.56841 12.0242M6.88961 8.72526C7.17132 8.40495 7.46766 8.08875 7.77818 7.77824C12.0739 3.48247 17.4558 1.89956 19.799 4.2427C21.4065 5.85021 21.1662 8.88795 19.4697 12.024M16.2635 7.77824C20.5592 12.074 22.1421 17.4559 19.799 19.7991C17.4558 22.1422 12.0739 20.5593 7.77818 16.2635C3.48241 11.9678 1.8995 6.58585 4.24264 4.2427C6.58579 1.89956 11.9677 3.48247 16.2635 7.77824ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Bot: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M20 14.0039H20.5C21.3284 14.0039 22 14.6751 22 15.503C22 16.331 21.3284 17.0022 20.5 17.0022H20V18.0017C20 19.6576 18.6569 21 17 21H7C5.34315 21 4 19.6576 4 18.0017V17.0022H3.5C2.67157 17.0022 2 16.331 2 15.503C2 14.6751 2.67157 14.0039 3.5 14.0039H4V13.0044C4 11.3485 5.34315 10.0061 7 10.0061H11H13H17C18.6569 10.0061 20 11.3485 20 13.0044V14.0039Z"
        {...fillProps}
      />
      <path
        d="M20.5 14.0039H20V13.0044C20 11.3485 18.6569 10.0061 17 10.0061H13H11H7C5.34315 10.0061 4 11.3485 4 13.0044V14.0039H3.5C2.67157 14.0039 2 14.6751 2 15.503C2 16.331 2.67157 17.0022 3.5 17.0022H4V18.0017C4 19.6576 5.34315 21 7 21H17C18.6569 21 20 19.6576 20 18.0017V17.0022H20.5C21.3284 17.0022 22 16.331 22 15.503C22 14.6751 21.3284 14.0039 20.5 14.0039Z"
        {...strokeProps}
      />
      <path
        d="M10 15.5031C10 16.331 9.32843 17.0022 8.5 17.0022C7.67157 17.0022 7 16.331 7 15.5031C7 14.6751 7.67157 14.0039 8.5 14.0039C9.32843 14.0039 10 14.6751 10 15.5031ZM17 15.5031C17 16.331 16.3284 17.0022 15.5 17.0022C14.6716 17.0022 14 16.331 14 15.5031C14 14.6751 14.6716 14.0039 15.5 14.0039C16.3284 14.0039 17 14.6751 17 15.5031Z"
        {...strokeProps}
      />
      <path
        d="M10 15.5031C10 16.331 9.32843 17.0022 8.5 17.0022C7.67157 17.0022 7 16.331 7 15.5031C7 14.6751 7.67157 14.0039 8.5 14.0039C9.32843 14.0039 10 14.6751 10 15.5031ZM17 15.5031C17 16.331 16.3284 17.0022 15.5 17.0022C14.6716 17.0022 14 16.331 14 15.5031C14 14.6751 14.6716 14.0039 15.5 14.0039C16.3284 14.0039 17 14.6751 17 15.5031Z"
        {...strokeProps}
      />
      <path
        d="M12 9V7M12 7C11 7 10 6 10 5C10 4 10.5 3 12 3C13.5 3 14 4 14 5C14 6 13 7 12 7Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const TrendUp: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M22 7L14.1314 14.8686C13.7354 15.2646 13.5373 15.4627 13.309 15.5368C13.1082 15.6021 12.8918 15.6021 12.691 15.5368C12.4627 15.4627 12.2646 15.2646 11.8686 14.8686L9.13137 12.1314C8.73535 11.7354 8.53735 11.5373 8.30902 11.4632C8.10817 11.3979 7.89183 11.3979 7.69098 11.4632C7.46265 11.5373 7.26465 11.7354 6.86863 12.1314L2 17M22 7H15M22 7V14"
        {...strokeProps}
      />
    </svg>
  );
};

export const Star: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M11.2827 3.45332C11.5131 2.98638 11.6284 2.75291 11.7848 2.67831C11.9209 2.61341 12.0791 2.61341 12.2152 2.67831C12.3717 2.75291 12.4869 2.98638 12.7174 3.45332L14.9041 7.88328C14.9721 8.02113 15.0061 8.09006 15.0558 8.14358C15.0999 8.19096 15.1527 8.22935 15.2113 8.25662C15.2776 8.28742 15.3536 8.29854 15.5057 8.32077L20.397 9.03571C20.9121 9.11099 21.1696 9.14863 21.2888 9.27444C21.3925 9.38389 21.4412 9.5343 21.4215 9.68377C21.3988 9.85558 21.2124 10.0372 20.8395 10.4004L17.3014 13.8464C17.1912 13.9538 17.136 14.0076 17.1004 14.0715C17.0689 14.128 17.0487 14.1902 17.0409 14.2545C17.0321 14.3271 17.0451 14.403 17.0711 14.5547L17.906 19.4221C17.994 19.9355 18.038 20.1922 17.9553 20.3445C17.8833 20.477 17.7554 20.57 17.6071 20.5975C17.4366 20.6291 17.2061 20.5078 16.7451 20.2654L12.3724 17.9658C12.2361 17.8942 12.168 17.8584 12.0962 17.8443C12.0327 17.8318 11.9673 17.8318 11.9038 17.8443C11.832 17.8584 11.7639 17.8942 11.6277 17.9658L7.25492 20.2654C6.79392 20.5078 6.56341 20.6291 6.39297 20.5975C6.24468 20.57 6.11672 20.477 6.04474 20.3445C5.962 20.1922 6.00603 19.9355 6.09407 19.4221L6.92889 14.5547C6.95491 14.403 6.96793 14.3271 6.95912 14.2545C6.95132 14.1902 6.93111 14.128 6.89961 14.0715C6.86402 14.0076 6.80888 13.9538 6.69859 13.8464L3.16056 10.4004C2.78766 10.0372 2.60121 9.85558 2.57853 9.68377C2.55879 9.5343 2.60755 9.38389 2.71125 9.27444C2.83044 9.14863 3.08797 9.11099 3.60304 9.03571L8.49431 8.32077C8.64642 8.29854 8.72248 8.28742 8.78872 8.25662C8.84736 8.22935 8.90016 8.19096 8.94419 8.14358C8.99391 8.09006 9.02793 8.02113 9.09597 7.88328L11.2827 3.45332Z"
        {...fillProps}
      />
      <path
        d="M11.2827 3.45332C11.5131 2.98638 11.6284 2.75291 11.7848 2.67831C11.9209 2.61341 12.0791 2.61341 12.2152 2.67831C12.3717 2.75291 12.4869 2.98638 12.7174 3.45332L14.9041 7.88328C14.9721 8.02113 15.0061 8.09006 15.0558 8.14358C15.0999 8.19096 15.1527 8.22935 15.2113 8.25662C15.2776 8.28742 15.3536 8.29854 15.5057 8.32077L20.397 9.03571C20.9121 9.11099 21.1696 9.14863 21.2888 9.27444C21.3925 9.38389 21.4412 9.5343 21.4215 9.68377C21.3988 9.85558 21.2124 10.0372 20.8395 10.4004L17.3014 13.8464C17.1912 13.9538 17.136 14.0076 17.1004 14.0715C17.0689 14.128 17.0487 14.1902 17.0409 14.2545C17.0321 14.3271 17.0451 14.403 17.0711 14.5547L17.906 19.4221C17.994 19.9355 18.038 20.1922 17.9553 20.3445C17.8833 20.477 17.7554 20.57 17.6071 20.5975C17.4366 20.6291 17.2061 20.5078 16.7451 20.2654L12.3724 17.9658C12.2361 17.8942 12.168 17.8584 12.0962 17.8443C12.0327 17.8318 11.9673 17.8318 11.9038 17.8443C11.832 17.8584 11.7639 17.8942 11.6277 17.9658L7.25492 20.2654C6.79392 20.5078 6.56341 20.6291 6.39297 20.5975C6.24468 20.57 6.11672 20.477 6.04474 20.3445C5.962 20.1922 6.00603 19.9355 6.09407 19.4221L6.92889 14.5547C6.95491 14.403 6.96793 14.3271 6.95912 14.2545C6.95132 14.1902 6.93111 14.128 6.89961 14.0715C6.86402 14.0076 6.80888 13.9538 6.69859 13.8464L3.16056 10.4004C2.78766 10.0372 2.60121 9.85558 2.57853 9.68377C2.55879 9.5343 2.60755 9.38389 2.71125 9.27444C2.83044 9.14863 3.08797 9.11099 3.60304 9.03571L8.49431 8.32077C8.64642 8.29854 8.72248 8.28742 8.78872 8.25662C8.84736 8.22935 8.90016 8.19096 8.94419 8.14358C8.99391 8.09006 9.02793 8.02113 9.09597 7.88328L11.2827 3.45332Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Smile: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        {...fillProps}
      />
      <path
        d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Pin: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M6.87769 4.19423C6.58366 3.45914 6.43664 3.09159 6.49795 2.79655C6.55157 2.53853 6.70486 2.31211 6.92451 2.1665C7.17568 2 7.57154 2 8.36326 2H15.6367C16.4285 2 16.8243 2 17.0755 2.1665C17.2951 2.31211 17.4484 2.53853 17.5021 2.79655C17.5634 3.09159 17.4163 3.45914 17.1223 4.19423L16.1144 6.71391C16.0717 6.8208 16.0503 6.87424 16.0353 6.92937C16.0219 6.97833 16.0123 7.02825 16.0065 7.07868C16 7.13544 16 7.19301 16 7.30813V9.43875C16 9.64677 16 9.75078 16.0204 9.85026C16.0385 9.93852 16.0685 10.0239 16.1095 10.1042C16.1557 10.1946 16.2207 10.2758 16.3506 10.4383L17.9204 12.4005C18.5861 13.2327 18.919 13.6487 18.9194 13.9989C18.9197 14.3035 18.7812 14.5916 18.5432 14.7815C18.2696 15 17.7367 15 16.671 15H7.329C6.2633 15 5.73045 15 5.45678 14.7815C5.21876 14.5916 5.0803 14.3035 5.08063 13.9989C5.08101 13.6487 5.41387 13.2327 6.07961 12.4005L7.64939 10.4383C7.77934 10.2758 7.84431 10.1946 7.89052 10.1042C7.93151 10.0239 7.96147 9.93852 7.97959 9.85026C8 9.75078 8 9.64677 8 9.43875V7.30813C8 7.19301 8 7.13544 7.99349 7.07868C7.98771 7.02825 7.9781 6.97833 7.96474 6.92937C7.9497 6.87424 7.92832 6.8208 7.88557 6.71391L6.87769 4.19423Z"
        {...fillProps}
      />
      <path
        d="M12 15L12 22M8 7.30813V9.43875C8 9.64677 8 9.75078 7.97959 9.85026C7.96147 9.93852 7.93151 10.0239 7.89052 10.1042C7.84431 10.1946 7.77934 10.2758 7.64939 10.4383L6.07961 12.4005C5.41387 13.2327 5.08101 13.6487 5.08063 13.9989C5.0803 14.3035 5.21876 14.5916 5.45678 14.7815C5.73045 15 6.2633 15 7.329 15H16.671C17.7367 15 18.2696 15 18.5432 14.7815C18.7812 14.5916 18.9197 14.3035 18.9194 13.9989C18.919 13.6487 18.5861 13.2327 17.9204 12.4005L16.3506 10.4383C16.2207 10.2758 16.1557 10.1946 16.1095 10.1042C16.0685 10.0239 16.0385 9.93852 16.0204 9.85026C16 9.75078 16 9.64677 16 9.43875V7.30813C16 7.19301 16 7.13544 16.0065 7.07868C16.0123 7.02825 16.0219 6.97833 16.0353 6.92937C16.0503 6.87424 16.0717 6.8208 16.1144 6.71391L17.1223 4.19423C17.4163 3.45914 17.5634 3.09159 17.5021 2.79655C17.4484 2.53853 17.2951 2.31211 17.0755 2.1665C16.8243 2 16.4285 2 15.6367 2H8.36326C7.57154 2 7.17568 2 6.92451 2.1665C6.70486 2.31211 6.55157 2.53853 6.49795 2.79655C6.43664 3.09159 6.58366 3.45914 6.87769 4.19423L7.88557 6.71391C7.92832 6.8208 7.9497 6.87424 7.96474 6.92937C7.9781 6.97833 7.98771 7.02825 7.99349 7.07868C8 7.13544 8 7.19301 8 7.30813Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Check: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path d="M20 6L9 17L4 12" {...strokeProps} />
    </svg>
  );
};

export const XMarkCircle: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        {...fillProps}
      />
      <path
        d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        {...strokeProps}
      />
    </svg>
  );
};


export const PersonAdd: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M9 11C10.933 11 12.5 9.433 12.5 7.5C12.5 5.567 10.933 4 9 4C7.067 4 5.5 5.567 5.5 7.5C5.5 9.433 7.067 11 9 11Z"
        {...fillProps}
      />
      <path
        d="M19 10V4M16 7H22M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const XMark: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path d="M18 6L6 18M6 6L18 18" {...strokeProps} />
    </svg>
  );
};

export const Image: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M6.36567 19.6343L14.8686 11.1314C15.2646 10.7354 15.4626 10.5373 15.691 10.4632C15.8918 10.3979 16.1082 10.3979 16.309 10.4632C16.5373 10.5373 16.7353 10.7354 17.1314 11.1314L21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9264 20.3854 19.362 20.673C18.7202 21 17.8801 21 16.2 21H6.93136C6.32554 21 6.02264 21 5.88237 20.8802C5.76067 20.7763 5.69608 20.6203 5.70864 20.4608C5.72311 20.2769 5.9373 20.0627 6.36567 19.6343Z"
        {...fillProps}
      />
      <path
        d="M8.49999 10.5C9.60456 10.5 10.5 9.60457 10.5 8.5C10.5 7.39543 9.60456 6.5 8.49999 6.5C7.39542 6.5 6.49999 7.39543 6.49999 8.5C6.49999 9.60457 7.39542 10.5 8.49999 10.5Z"
        {...fillProps}
      />
      <path
        d="M16.2 21H6.93137C6.32555 21 6.02265 21 5.88238 20.8802C5.76068 20.7763 5.69609 20.6203 5.70865 20.4608C5.72312 20.2769 5.93731 20.0627 6.36569 19.6343L14.8686 11.1314C15.2646 10.7354 15.4627 10.5373 15.691 10.4632C15.8918 10.3979 16.1082 10.3979 16.309 10.4632C16.5373 10.5373 16.7354 10.7354 17.1314 11.1314L21 15V16.2M16.2 21C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2M16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const AlignLeft: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path d="M16 10H3M20 6H3M20 14H3M16 18H3" {...strokeProps} />
    </svg>
  );
};

export const Scan: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M8 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V8M8 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V16M21 8V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H16M21 16V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H16M3 12H3.01M7.5 12H7.51M16.5 12H16.51M12 12H12.01M21 12H21.01"
        {...strokeProps}
      />
    </svg>
  );
};

export const ClipboardAdd: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M8 3.6C8 3.03995 8 2.75992 8.10899 2.54601C8.20487 2.35785 8.35785 2.20487 8.54601 2.10899C8.75992 2 9.03995 2 9.6 2H14.4C14.9601 2 15.2401 2 15.454 2.10899C15.6422 2.20487 15.7951 2.35785 15.891 2.54601C16 2.75992 16 3.03995 16 3.6V4.4C16 4.96005 16 5.24008 15.891 5.45399C15.7951 5.64215 15.6422 5.79513 15.454 5.89101C15.2401 6 14.9601 6 14.4 6H9.6C9.03995 6 8.75992 6 8.54601 5.89101C8.35785 5.79513 8.20487 5.64215 8.10899 5.45399C8 5.24008 8 4.96005 8 4.4V3.6Z"
        {...fillProps}
      />
      <path
        d="M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 4 7.07003 4 8 4M12 17V11M9 14H15M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Pen: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M20.1314 10.8686C19.7354 11.2646 19.5373 11.4626 19.309 11.5368C19.1082 11.6021 18.8918 11.6021 18.691 11.5368C18.4627 11.4626 18.2646 11.2646 17.8686 10.8686L13.1314 6.13134C12.7354 5.73532 12.5373 5.53732 12.4632 5.30899C12.3979 5.10814 12.3979 4.8918 12.4632 4.69095C12.5373 4.46263 12.7354 4.26462 13.1314 3.8686L13.8686 3.13134C14.2646 2.73533 14.4627 2.53732 14.691 2.46313C14.8918 2.39787 15.1082 2.39787 15.309 2.46313C15.5373 2.53732 15.7354 2.73532 16.1314 3.13134L20.8686 7.8686C21.2646 8.26462 21.4627 8.46263 21.5368 8.69095C21.6021 8.8918 21.6021 9.10814 21.5368 9.30899C21.4627 9.53732 21.2646 9.73532 20.8686 10.1313L20.1314 10.8686Z"
        {...fillProps}
      />
      <path
        d="M13 13C13 11.8954 12.1046 11 11 11C9.89543 11 9 11.8954 9 13C9 14.1045 9.89543 15 11 15C12.1046 15 13 14.1045 13 13Z"
        {...fillProps}
      />
      <path
        d="M13 5.99997L6.50182 7.29961C6.13883 7.37221 5.95733 7.40851 5.80952 7.49677C5.67886 7.57481 5.56772 7.68164 5.4846 7.80913C5.39057 7.95334 5.34714 8.13326 5.26028 8.49311L2 22M2 22L15.5069 18.7397C15.8667 18.6528 16.0466 18.6094 16.1908 18.5154C16.3183 18.4322 16.4252 18.3211 16.5032 18.1904C16.5915 18.0426 16.6278 17.8611 16.7004 17.4981L18 11M2 22L9.586 14.414M20.8686 7.8686L16.1314 3.13134C15.7354 2.73532 15.5373 2.53732 15.309 2.46313C15.1082 2.39787 14.8918 2.39787 14.691 2.46313C14.4627 2.53732 14.2646 2.73533 13.8686 3.13134L13.1314 3.8686C12.7354 4.26462 12.5373 4.46263 12.4632 4.69095C12.3979 4.8918 12.3979 5.10814 12.4632 5.30899C12.5373 5.53732 12.7354 5.73532 13.1314 6.13134L17.8686 10.8686C18.2646 11.2646 18.4627 11.4626 18.691 11.5368C18.8918 11.6021 19.1082 11.6021 19.309 11.5368C19.5373 11.4626 19.7354 11.2646 20.1314 10.8686L20.8686 10.1313C21.2646 9.73532 21.4627 9.53732 21.5368 9.30899C21.6021 9.10814 21.6021 8.8918 21.5368 8.69095C21.4627 8.46263 21.2646 8.26462 20.8686 7.8686ZM11 11C12.1046 11 13 11.8954 13 13C13 14.1045 12.1046 15 11 15C9.89543 15 9 14.1045 9 13C9 11.8954 9.89543 11 11 11Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Pricing: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M11.302 21.615C11.5234 21.7442 11.6341 21.8087 11.7903 21.8422C11.9116 21.8682 12.0884 21.8682 12.2097 21.8422C12.3659 21.8087 12.4766 21.7442 12.698 21.615C14.646 20.4785 20 16.9086 20 12.0001V7.21772C20 6.4182 20 6.01845 19.8692 5.67482C19.7537 5.37126 19.566 5.10039 19.3223 4.88564C19.0465 4.64255 18.6722 4.50219 17.9236 4.22146L12.5618 2.21079C12.3539 2.13283 12.25 2.09385 12.143 2.07839C12.0482 2.06469 11.9518 2.06469 11.857 2.07839C11.75 2.09385 11.6461 2.13283 11.4382 2.21079L6.0764 4.22146C5.3278 4.50219 4.9535 4.64255 4.67766 4.88564C4.43398 5.10039 4.24627 5.37126 4.13076 5.67482C4 6.01845 4 6.4182 4 7.21772V12.0001C4 16.9086 9.35396 20.4785 11.302 21.615Z"
        {...fillProps}
      />
      <path
        d="M9.21296 14.5C9.52517 15.0945 10.1486 15.5 10.8667 15.5H13C14.1046 15.5 15 14.6046 15 13.5C15 12.3954 14.1046 11.5 13 11.5H11C9.89543 11.5 9 10.6046 9 9.49999C9 8.39542 9.89543 7.49999 11 7.49999H13.1333C13.8514 7.49999 14.4748 7.90549 14.787 8.49999M12 5.99999V7.49999M12 15.5V17M20 12C20 16.9084 14.646 20.4784 12.698 21.6149C12.4766 21.744 12.3659 21.8086 12.2097 21.8421C12.0884 21.8681 11.9116 21.8681 11.7903 21.8421C11.6341 21.8086 11.5234 21.744 11.302 21.6149C9.35396 20.4784 4 16.9084 4 12V7.21759C4 6.41808 4 6.01833 4.13076 5.6747C4.24627 5.37113 4.43398 5.10027 4.67766 4.88552C4.9535 4.64243 5.3278 4.50207 6.0764 4.22134L11.4382 2.21067C11.6461 2.13271 11.75 2.09373 11.857 2.07827C11.9518 2.06457 12.0482 2.06457 12.143 2.07827C12.25 2.09373 12.3539 2.13271 12.5618 2.21067L17.9236 4.22134C18.6722 4.50207 19.0465 4.64243 19.3223 4.88552C19.566 5.10027 19.7537 5.37113 19.8692 5.6747C20 6.01833 20 6.41808 20 7.21759V12Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Trophy: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M6 3.44444C6 3.0306 6 2.82367 6.06031 2.65798C6.16141 2.38021 6.38021 2.16141 6.65798 2.06031C6.82367 2 7.0306 2 7.44444 2H16.5556C16.9694 2 17.1763 2 17.342 2.06031C17.6198 2.16141 17.8386 2.38021 17.9397 2.65798C18 2.82367 18 3.0306 18 3.44444V9C18 12.3137 15.3137 15 12 15C8.68629 15 6 12.3137 6 9V3.44444Z"
        {...fillProps}
      />
      <path
        d="M12 15C8.68629 15 6 12.3137 6 9V3.44444C6 3.0306 6 2.82367 6.06031 2.65798C6.16141 2.38021 6.38021 2.16141 6.65798 2.06031C6.82367 2 7.0306 2 7.44444 2H16.5556C16.9694 2 17.1763 2 17.342 2.06031C17.6198 2.16141 17.8386 2.38021 17.9397 2.65798C18 2.82367 18 3.0306 18 3.44444V9C18 12.3137 15.3137 15 12 15ZM12 15V18M18 4H20.5C20.9659 4 21.1989 4 21.3827 4.07612C21.6277 4.17761 21.8224 4.37229 21.9239 4.61732C22 4.80109 22 5.03406 22 5.5V6C22 6.92997 22 7.39496 21.8978 7.77646C21.6204 8.81173 20.8117 9.62038 19.7765 9.89778C19.395 10 18.93 10 18 10M6 4H3.5C3.03406 4 2.80109 4 2.61732 4.07612C2.37229 4.17761 2.17761 4.37229 2.07612 4.61732C2 4.80109 2 5.03406 2 5.5V6C2 6.92997 2 7.39496 2.10222 7.77646C2.37962 8.81173 3.18827 9.62038 4.22354 9.89778C4.60504 10 5.07003 10 6 10M7.44444 22H16.5556C16.801 22 17 21.801 17 21.5556C17 19.5919 15.4081 18 13.4444 18H10.5556C8.59188 18 7 19.5919 7 21.5556C7 21.801 7.19898 22 7.44444 22Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Gift: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M2.21799 8.09202C2 8.51984 2 9.0799 2 10.2V14H12V7H5.2C4.0799 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202Z"
        {...fillProps}
      />
      <path
        d="M21.782 20.908C22 20.4802 22 19.9201 22 18.8V14H12L12 22L18.8 22C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908Z"
        {...fillProps}
      />
      <path
        d="M12 7H7.5C6.83696 7 6.20107 6.73661 5.73223 6.26777C5.26339 5.79893 5 5.16304 5 4.5C5 3.83696 5.26339 3.20107 5.73223 2.73223C6.20107 2.26339 6.83696 2 7.5 2C11 2 12 7 12 7ZM12 7H16.5C17.163 7 17.7989 6.73661 18.2678 6.26777C18.7366 5.79893 19 5.16304 19 4.5C19 3.83696 18.7366 3.20107 18.2678 2.73223C17.7989 2.26339 17.163 2 16.5 2C13 2 12 7 12 7ZM12 7L12 22M2 14H22M2 10.2L2 18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22L18.8 22C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V10.2C22 9.0799 22 8.51984 21.782 8.09202C21.5903 7.7157 21.2843 7.40974 20.908 7.21799C20.4802 7 19.9201 7 18.8 7L5.2 7C4.0799 7 3.51984 7 3.09202 7.21799C2.7157 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Download: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M11.896 21.9995C17.4185 22.0569 21.942 17.6266 21.9995 12.104C22.0569 6.58148 17.6266 2.058 12.104 2.00056C6.58146 1.94311 2.05799 6.37346 2.00054 11.896C1.9431 17.4186 6.37344 21.942 11.896 21.9995Z"
        {...fillProps}
      />
      <path
        d="M8 12L12 16M12 16L16 12M12 16V8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const InfoCircle: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        {...fillProps}
      />
      <path
        d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const ArrowUpCircle: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        {...fillProps}
      />
      <path
        d="M16 12L12 8M12 8L8 12M12 8V16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        {...strokeProps}
      />
    </svg>
  );
};

export const Link: React.FC<React.HTMLProps<SVGElement>> = ({ className }) => {
  return (
    <svg className={className} {...svgProps}>
      <path
        d="M10 13C10.4295 13.5742 10.9774 14.0492 11.6066 14.393C12.2358 14.7367 12.9315 14.9411 13.6467 14.9924C14.3618 15.0436 15.0796 14.9404 15.7514 14.6898C16.4231 14.4392 17.0331 14.0471 17.54 13.54L20.54 10.54C21.4508 9.59702 21.9548 8.334 21.9434 7.02302C21.932 5.71204 21.4062 4.45797 20.4791 3.53093C19.5521 2.60389 18.298 2.07805 16.987 2.06666C15.676 2.05526 14.413 2.55924 13.47 3.47003L11.75 5.18003M14 11C13.5706 10.4259 13.0227 9.95084 12.3935 9.60709C11.7643 9.26333 11.0685 9.05891 10.3534 9.00769C9.63822 8.95648 8.92043 9.05966 8.24867 9.31025C7.57691 9.56083 6.9669 9.95296 6.46002 10.46L3.46002 13.46C2.54923 14.403 2.04525 15.666 2.05665 16.977C2.06804 18.288 2.59388 19.5421 3.52092 20.4691C4.44796 21.3962 5.70203 21.922 7.01301 21.9334C8.32399 21.9448 9.58701 21.4408 10.53 20.53L12.24 18.82"
        {...strokeProps}
      />
    </svg>
  );
};
